(function(){
'use strict';
const PROFILE_KEY='kp_machine_profile_v1';
const HIDE_KEY='kp_machine_hide_incompatible_v1';
const CACHE_PREFIX='kp_machine_fit_v2_';
const catalog=window.KP_MACHINE_CATALOG||{};
const MODELS={
  ses450:'Bambino · SES450',ses500:'Bambino Plus · SES500',ses810:'Duo Temp Pro · SES810',ses870:'Barista Express · SES870',ses875:'Barista Express · SES875',ses876:'Barista Express Impress · SES876',ses878:'Barista Pro · SES878',ses880:'Barista Touch · SES880',ses881:'Barista Touch Impress · SES881',ses920:'Dual Boiler · SES920',ses980:'The Oracle · SES980',ses990:'Oracle Touch · SES990'
};
const memoryCache=new Map();
let observer;
let refreshTimer;
let refreshSeq=0;

function readProfile(){
  try{
    const p=JSON.parse(localStorage.getItem(PROFILE_KEY)||'null');
    if(!p||p.brand!=='sage'||!p.model) return null;
    return {brand:'sage',model:String(p.model).toLowerCase(),pdc:parsePdc(p.pdc)};
  }catch(e){return null;}
}
function saveProfile(profile){
  localStorage.setItem(PROFILE_KEY,JSON.stringify({brand:'sage',model:profile.model,pdc:parsePdc(profile.pdc)}));
  document.dispatchEvent(new CustomEvent('kp:machine-changed'));
}
function clearProfile(){
  localStorage.removeItem(PROFILE_KEY);
  localStorage.removeItem(HIDE_KEY);
  document.dispatchEvent(new CustomEvent('kp:machine-changed'));
}
function parsePdc(value){
  const m=String(value||'').match(/\d+/);
  return m?parseInt(m[0],10):null;
}
function modelLabel(model){return MODELS[model]||String(model||'').toUpperCase();}
function shortModel(model){return String(model||'').toUpperCase();}
function getHandleFromHref(href){
  if(!href) return null;
  try{
    const path=new URL(href,location.origin).pathname;
    const m=path.match(/\/products\/([^/?#]+)/);
    return m?decodeURIComponent(m[1]):null;
  }catch(e){return null;}
}
function handleForNode(node){
  if(node.matches&&node.matches('a[href*="/products/"]')) return getHandleFromHref(node.getAttribute('href'));
  const link=node.querySelector&&node.querySelector('a[href*="/products/"]');
  return link?getHandleFromHref(link.getAttribute('href')):null;
}
function normalizeTags(tags){
  if(Array.isArray(tags)) return tags.map(String);
  if(!tags) return [];
  return String(tags).split(',').map(function(t){return t.trim();}).filter(Boolean);
}
function entryFromTags(tags){
  const list=normalizeTags(tags);
  if(!list.length) return null;
  const normalized=list.map(function(t){return t.toLowerCase();});
  if(normalized.indexOf('finder_universal_sage')!==-1) return {s:'u',c:'v'};
  const rules={};
  normalized.forEach(function(tag){
    const m=tag.match(/^finder_model_(ses\d+)$/);
    if(m&&!rules[m[1]]) rules[m[1]]={};
  });
  normalized.forEach(function(tag){
    let m=tag.match(/^finder_pdc_from_(ses\d+)_(\d+)$/);
    if(m){if(!rules[m[1]])rules[m[1]]={};rules[m[1]].from=parseInt(m[2],10);return;}
    m=tag.match(/^finder_pdc_until_(ses\d+)_(\d+)$/);
    if(m){if(!rules[m[1]])rules[m[1]]={};rules[m[1]].until=parseInt(m[2],10);}
  });
  const models=Object.keys(rules);
  if(!models.length){
    if(normalized.indexOf('finder_brand_sage')!==-1) return {c:'r',m:{}};
    return {s:'o',c:'v'};
  }
  models.forEach(function(model){
    const rule=rules[model];
    if(!rule.from&&!rule.until) rules[model]='1';
  });
  return {c:'v',m:rules};
}
function readCachedEntry(handle){
  if(memoryCache.has(handle)) return memoryCache.get(handle);
  try{
    const raw=sessionStorage.getItem(CACHE_PREFIX+handle);
    if(raw){const parsed=JSON.parse(raw);memoryCache.set(handle,parsed);return parsed;}
  }catch(e){}
  return undefined;
}
function writeCachedEntry(handle,entry){
  memoryCache.set(handle,entry);
  try{sessionStorage.setItem(CACHE_PREFIX+handle,JSON.stringify(entry));}catch(e){}
}
async function entryForHandle(handle){
  if(!handle) return null;
  const cached=readCachedEntry(handle);
  if(cached!==undefined) return cached;
  const root=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
  try{
    const response=await fetch(root+'products/'+encodeURIComponent(handle)+'.js',{headers:{Accept:'application/json'},credentials:'same-origin'});
    if(!response.ok) throw new Error('HTTP '+response.status);
    const product=await response.json();
    const live=entryFromTags(product.tags);
    const entry=live||catalog[handle]||null;
    writeCachedEntry(handle,entry);
    return entry;
  }catch(e){
    const fallback=catalog[handle]||null;
    writeCachedEntry(handle,fallback);
    return fallback;
  }
}
function classify(entry,profile){
  if(!profile) return 'none';
  if(!entry) return 'unknown';
  if(entry.s==='u') return 'universal';
  if(entry.s==='o') return 'fail';
  if(entry.c==='r') return 'unknown';
  const rules=entry.m||{};
  const rule=rules[profile.model];
  if(!rule) return entry.c==='v'?'fail':'unknown';
  if(rule==='1') return 'pass';
  if(typeof rule==='object'){
    if(!profile.pdc) return 'pdc';
    if(rule.from&&profile.pdc<rule.from) return 'fail';
    if(rule.until&&profile.pdc>rule.until) return 'fail';
    return 'pass';
  }
  const threshold=parseInt(String(rule).replace(/\D/g,''),10);
  if(!threshold) return 'unknown';
  if(!profile.pdc) return 'pdc';
  if(String(rule).indexOf('>=')===0) return profile.pdc>=threshold?'pass':'fail';
  if(String(rule).indexOf('<=')===0) return profile.pdc<=threshold?'pass':'fail';
  return 'unknown';
}
function statusText(status,profile){
  const code=shortModel(profile&&profile.model);
  if(status==='pass') return '✓ Passer til din '+code;
  if(status==='fail') return 'Passer ikke til din '+code;
  if(status==='pdc') return 'Kontrollér PDC';
  if(status==='universal') return 'Universel del';
  return 'Kompatibilitet ikke verificeret';
}
function rank(status){
  if(status==='pass') return 0;
  if(status==='universal') return 1;
  if(status==='pdc'||status==='unknown') return 2;
  if(status==='fail') return 3;
  return 2;
}
function ensureSelector(){
  const host=document.querySelector('.kp-evos-home');
  const target=document.querySelector('.kp-search-zone');
  const tpl=document.getElementById('kp-machine-selector-template');
  if(!host||!target||!tpl||document.getElementById('kp-machine-selector')) return;
  target.insertAdjacentElement('beforebegin',tpl.content.firstElementChild.cloneNode(true));
  bindSelector(document.getElementById('kp-machine-selector'));
  if(location.hash==='#kp-machine-selector'||new URLSearchParams(location.search).get('kp_machine_change')==='1'){
    setTimeout(function(){document.getElementById('kp-machine-selector').scrollIntoView({behavior:'smooth',block:'start'});},100);
  }
}
function bindSelector(root){
  if(!root||root.dataset.kpBound==='1') return;
  root.dataset.kpBound='1';
  const form=root.querySelector('[data-kp-machine-form]');
  const model=form.querySelector('[data-kp-machine-model]');
  const pdc=form.querySelector('[data-kp-machine-pdc]');
  const clear=form.querySelector('[data-kp-machine-clear]');
  const feedback=root.querySelector('[data-kp-machine-feedback]');
  const profile=readProfile();
  if(profile){model.value=profile.model;pdc.value=profile.pdc||'';clear.hidden=false;feedback.textContent='Valgt: '+modelLabel(profile.model)+(profile.pdc?' · PDC '+profile.pdc:'');}
  form.addEventListener('submit',function(e){
    e.preventDefault();
    if(!model.value){model.focus();return;}
    saveProfile({brand:'sage',model:model.value,pdc:pdc.value});
    clear.hidden=false;
    const current=readProfile();
    feedback.textContent='Gemt: '+modelLabel(current.model)+(current.pdc?' · PDC '+current.pdc:'');
    refreshAll();
  });
  clear.addEventListener('click',function(){
    clearProfile();model.value='';pdc.value='';clear.hidden=true;feedback.textContent='Maskinevalg fjernet.';refreshAll();
  });
}
function ensureProfileBar(){
  let bar=document.querySelector('[data-kp-machine-bar]');
  const tpl=document.getElementById('kp-machine-bar-template');
  if(!bar&&tpl){
    bar=tpl.content.firstElementChild.cloneNode(true);
    const header=document.querySelector('.header-wrapper');
    const section=header&&header.closest('.shopify-section');
    if(section) section.insertAdjacentElement('afterend',bar); else document.body.insertAdjacentElement('afterbegin',bar);
    bar.querySelector('[data-kp-machine-change]').addEventListener('click',function(){
      const selector=document.getElementById('kp-machine-selector');
      if(selector){selector.scrollIntoView({behavior:'smooth',block:'start'});const select=selector.querySelector('[data-kp-machine-model]');if(select) setTimeout(function(){select.focus();},450);}
      else location.href='/?kp_machine_change=1#kp-machine-selector';
    });
  }
  if(!bar) return;
  const profile=readProfile();
  if(!profile){bar.hidden=true;return;}
  bar.hidden=false;
  const name=bar.querySelector('[data-kp-machine-name]');
  const pdc=bar.querySelector('[data-kp-machine-bar-pdc]');
  if(name) name.textContent=modelLabel(profile.model);
  if(pdc){pdc.textContent=profile.pdc?'PDC '+profile.pdc:'PDC ikke angivet';pdc.classList.toggle('is-missing',!profile.pdc);}
}
function decorateCard(item,status,profile){
  item.classList.remove('kp-machine-fit--pass','kp-machine-fit--fail','kp-machine-fit--pdc','kp-machine-fit--unknown','kp-machine-fit--universal');
  item.classList.add('kp-machine-fit--'+status);
  let badge=item.querySelector('.kp-machine-card-badge');
  if(status==='unknown'||status==='none'){
    if(badge) badge.remove();
    return;
  }
  if(!badge){
    badge=document.createElement('span');badge.className='kp-machine-card-badge';
    const infos=item.querySelectorAll('.card__information');
    const info=infos.length?infos[infos.length-1]:item.querySelector('.card__content');
    if(info) info.insertAdjacentElement('afterbegin',badge);
  }
  if(badge){badge.className='kp-machine-card-badge kp-machine-card-badge--'+status;badge.textContent=statusText(status,profile);}
}
function ensureFilterBar(grid,profile,counts){
  const container=grid.closest('.product-grid-container')||grid.parentElement;
  if(!container) return;
  let bar=container.parentElement&&container.parentElement.querySelector(':scope > .kp-machine-filterbar');
  if(!bar){
    bar=document.createElement('div');bar.className='kp-machine-filterbar';
    bar.innerHTML='<div class="kp-machine-filterbar__copy"><span>Min maskine</span><strong data-kp-filter-machine></strong><small data-kp-filter-stats></small></div><label class="kp-machine-toggle"><input type="checkbox" data-kp-hide-incompatible><span>Skjul produkter der ikke passer</span></label>';
    container.insertAdjacentElement('beforebegin',bar);
    const checkbox=bar.querySelector('[data-kp-hide-incompatible]');
    checkbox.checked=localStorage.getItem(HIDE_KEY)==='1';
    checkbox.addEventListener('change',function(){localStorage.setItem(HIDE_KEY,this.checked?'1':'0');refreshAll();});
  }
  const machine=bar.querySelector('[data-kp-filter-machine]');
  const stats=bar.querySelector('[data-kp-filter-stats]');
  const checkbox=bar.querySelector('[data-kp-hide-incompatible]');
  const machineText=modelLabel(profile.model)+(profile.pdc?' · PDC '+profile.pdc:'');
  if(machine&&machine.textContent!==machineText) machine.textContent=machineText;
  const statText=counts.pass+' match · '+counts.check+' skal kontrolleres · '+counts.fail+' passer ikke';
  if(stats&&stats.textContent!==statText) stats.textContent=statText;
  if(checkbox) checkbox.setAttribute('aria-label','Skjul produkter der ikke passer til '+shortModel(profile.model));
}
async function processGrid(grid,profile,seq){
  const items=Array.from(grid.children).filter(function(el){return el.matches&&el.matches('.grid__item');});
  if(!items.length) return;
  const hide=localStorage.getItem(HIDE_KEY)==='1';
  const evaluated=await Promise.all(items.map(async function(item,index){
    if(!item.dataset.kpOriginalIndex) item.dataset.kpOriginalIndex=String(index+1);
    const handle=handleForNode(item);
    const entry=await entryForHandle(handle);
    const status=handle?classify(entry,profile):'unknown';
    return {item:item,status:status,original:parseInt(item.dataset.kpOriginalIndex,10)||index};
  }));
  if(seq!==refreshSeq) return;
  let pass=0,check=0,fail=0;
  evaluated.forEach(function(row){
    if(row.status==='pass') pass++;
    else if(row.status==='fail') fail++;
    else if(row.status!=='universal') check++;
    row.item.hidden=hide&&row.status==='fail';
    decorateCard(row.item,row.status,profile);
  });
  const sorted=evaluated.slice().sort(function(a,b){return rank(a.status)-rank(b.status)||a.original-b.original;});
  const current=Array.from(grid.children);
  const desired=sorted.map(function(x){return x.item;});
  let different=false;
  desired.forEach(function(el,i){if(current[i]!==el) different=true;});
  if(different) desired.forEach(function(el){grid.appendChild(el);});
  ensureFilterBar(grid,profile,{pass:pass,check:check,fail:fail});
}
async function applyGrids(seq){
  const profile=readProfile();
  const bars=document.querySelectorAll('.kp-machine-filterbar');
  if(!profile){
    bars.forEach(function(b){b.remove();});
    document.querySelectorAll('.grid__item').forEach(function(item){item.hidden=false;item.classList.remove('kp-machine-fit--pass','kp-machine-fit--fail','kp-machine-fit--pdc','kp-machine-fit--unknown','kp-machine-fit--universal');const badge=item.querySelector('.kp-machine-card-badge');if(badge)badge.remove();});
    return;
  }
  await Promise.all(Array.from(document.querySelectorAll('ul.product-grid')).map(function(grid){return processGrid(grid,profile,seq);}));
}
async function decorateFeatured(seq){
  const profile=readProfile();
  const cards=Array.from(document.querySelectorAll('.kp-feature-card'));
  await Promise.all(cards.map(async function(card){
    const handle=handleForNode(card);
    const entry=profile&&handle?await entryForHandle(handle):null;
    if(seq!==refreshSeq) return;
    const status=profile&&handle?classify(entry,profile):'none';
    card.classList.remove('kp-machine-fit--pass','kp-machine-fit--fail','kp-machine-fit--pdc','kp-machine-fit--unknown','kp-machine-fit--universal');
    if(status!=='none') card.classList.add('kp-machine-fit--'+status);
    let badge=card.querySelector('.kp-machine-feature-badge');
    if(profile&&(status==='pass'||status==='fail'||status==='pdc')){
      if(!badge){badge=document.createElement('span');badge.className='kp-machine-feature-badge';const img=card.querySelector('.kp-feature-image');if(img)img.insertAdjacentElement('afterend',badge);}
      if(badge){badge.className='kp-machine-feature-badge kp-machine-feature-badge--'+status;badge.textContent=statusText(status,profile);}
    }else if(badge) badge.remove();
  }));
}
async function decorateProductPage(seq){
  const title=document.querySelector('.product__title');
  if(!title) return;
  const handle=getHandleFromHref(location.pathname);
  const profile=readProfile();
  let box=document.querySelector('.kp-product-machine-status');
  if(!profile){if(box)box.remove();return;}
  const entry=await entryForHandle(handle);
  if(seq!==refreshSeq) return;
  const status=classify(entry,profile);
  if(!box){box=document.createElement('div');box.className='kp-product-machine-status';title.insertAdjacentElement('afterend',box);}
  box.className='kp-product-machine-status kp-product-machine-status--'+status;
  let detail='';
  if(status==='pass') detail='Denne reservedel er matchet mod din valgte maskine.';
  else if(status==='fail') detail='Denne reservedel er ikke et verificeret match til din valgte maskine.';
  else if(status==='pdc') detail='Delen findes i flere produktionsversioner. Tilføj PDC for et sikkert match.';
  else if(status==='universal') detail='Denne vare er universel og afhænger ikke af den valgte maskinmodel.';
  else detail='Vi har ikke data nok til at give et sikkert match på denne del endnu.';
  box.innerHTML='<strong>'+statusText(status,profile)+'</strong><span>'+detail+'</span><button type="button" data-kp-product-change>Skift maskine</button>';
  box.querySelector('[data-kp-product-change]').addEventListener('click',function(){location.href='/?kp_machine_change=1#kp-machine-selector';});
}
function syncSelector(){
  const root=document.getElementById('kp-machine-selector');
  if(!root) return;
  const profile=readProfile();
  const model=root.querySelector('[data-kp-machine-model]');
  const pdc=root.querySelector('[data-kp-machine-pdc]');
  const clear=root.querySelector('[data-kp-machine-clear]');
  if(profile){if(model)model.value=profile.model;if(pdc)pdc.value=profile.pdc||'';if(clear)clear.hidden=false;}
}
async function refreshAll(){
  const seq=++refreshSeq;
  ensureSelector();syncSelector();ensureProfileBar();
  await Promise.all([applyGrids(seq),decorateFeatured(seq),decorateProductPage(seq)]);
}
function scheduleRefresh(){clearTimeout(refreshTimer);refreshTimer=setTimeout(refreshAll,120);}
function init(){
  refreshAll();
  document.addEventListener('kp:machine-changed',scheduleRefresh);
  observer=new MutationObserver(function(mutations){
    const relevant=mutations.some(function(m){return Array.from(m.addedNodes||[]).some(function(n){return n.nodeType===1&&(n.matches&&n.matches('.product-grid,.grid__item,#ProductGridContainer')||n.querySelector&&n.querySelector('.product-grid,.grid__item'));});});
    if(relevant) scheduleRefresh();
  });
  observer.observe(document.body,{childList:true,subtree:true});
}
if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init); else init();
})();
